import { createHttpClient } from '../../../core/api';
import { requireEnv } from '../../../core/utils/env';

export const FC_MOVIDESK_API_URL = requireEnv('REACT_APP_FC_MOVIDESK_API_URL');

/**
 * BFF interno (Ferreira Costa) que expõe os valores de campos custom e a criação de ticket do form
 * de suporte. A chave de acesso é injetada pelo nginx do próprio site, nunca pelo navegador.
 */
export const fcMovideskHttpClient = createHttpClient({ baseURL: FC_MOVIDESK_API_URL });
